// // src/hooks/usePageTitle.js
// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { Helmet } from "react-helmet";

// const usePageTitle = (titles) => {
//   const location = useLocation();

//   useEffect(() => {
//     const currentPath = location.pathname;
//     const title = titles[currentPath] || "Default Title";
//     document.title = title;
//   }, [location, titles]);
// };

// export default usePageTitle;

// hooks/usePageTitle.js
import { useEffect } from "react";
import { Helmet } from "react-helmet";

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default usePageTitle;
